'use strict';

module.exports = require('es6-symbol').for('isObservable');
